"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaButtonLabelProperty = exports.ctaButtonLabelPropertyDefinition = void 0;
exports.ctaButtonLabelPropertyDefinition = {
    view: { label: 'Button label' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'cta-button-label',
};
const isCtaButtonLabelProperty = (prop) => {
    return prop.name === exports.ctaButtonLabelPropertyDefinition.name;
};
exports.isCtaButtonLabelProperty = isCtaButtonLabelProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWJ1dHRvbi1sYWJlbC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2N0YS1idXR0b24tbGFiZWwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsY0FBYyxFQUFFO0lBQy9CLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxrQkFBa0I7Q0FDTyxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=